var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 469,
    height: 468,
    viewBox: "0 0 469 468",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.438 0H146.562C65.6307 0 0 65.4908 0 146.25V321.75C0 402.509 65.6307 468 146.562 468H322.438C403.369 468 469 402.509 469 321.75V146.25C469 65.4908 403.369 0 322.438 0ZM425.031 321.75C425.031 378.202 379.011 424.125 322.438 424.125H146.562C89.9894 424.125 43.9688 378.202 43.9688 321.75V146.25C43.9688 89.7975 89.9894 43.875 146.562 43.875H322.438C379.011 43.875 425.031 89.7975 425.031 146.25V321.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.5 117C169.749 117 117.25 169.387 117.25 234C117.25 298.613 169.749 351 234.5 351C299.251 351 351.75 298.613 351.75 234C351.75 169.387 299.251 117 234.5 117ZM234.5 307.125C194.107 307.125 161.219 274.307 161.219 234C161.219 193.664 194.107 160.875 234.5 160.875C274.893 160.875 307.781 193.664 307.781 234C307.781 274.307 274.893 307.125 234.5 307.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia);
export default __webpack_public_path__ + "static/media/Social_media.e20fa742669fab3b30242bd8bc2839f8.svg";
export { ForwardRef as ReactComponent };